module.exports = __webpack_public_path__ + "static/media/welcome.33b6fc97.jpg";